import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './promotions.magic.css.js';
import PromotionsComponent from './promotions.js';

const __vue_script__ = PromotionsComponent;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "promotions",
      attrs: { part: "promotions", "data-v-test-id": "promotions" }
    },
    [
      _vm.isLoading
        ? _c("magic-ui-loader")
        : !_vm.isLoading && _vm.promotions.length
        ? [
            !_vm.hideCategoriesSelector
              ? _c(
                  "div",
                  {
                    staticClass: "categories-menu",
                    attrs: {
                      part: "categories-menu",
                      "data-v-test-id": "promotions-menu"
                    }
                  },
                  [
                    _c("magic-ui-collapsible-row", {
                      staticClass:
                        "collapsible-row collapsible-row--promotions",
                      attrs: {
                        part: "collapsible-row collapsible-row--promotions",
                        left: _vm.alignCategoriesLeft,
                        "active-item": _vm.activeTab
                      },
                      domProps: { items: _vm.collapsibleItems },
                      on: {
                        "item-click": _vm.selectCategory,
                        hidden: function($event) {
                          return _vm.setHiddenCategories($event.detail[0])
                        }
                      }
                    }),
                    _vm._v(" "),
                    !!_vm.hiddenCategories.length
                      ? _c(
                          "magic-ui-form-field",
                          {
                            staticClass: "dropdown",
                            attrs: {
                              "no-margin": "",
                              part: "dropdown",
                              "aria-label": _vm.$t(
                                "promotions.categories.dropdown.aria-label"
                              )
                            }
                          },
                          [
                            _c("magic-ui-dropdown", {
                              attrs: {
                                link: "",
                                "allow-empty": "",
                                ellipsis: "",
                                placeholder: _vm.$t(
                                  "promotions.more-categories"
                                ),
                                value: _vm.activeTab
                              },
                              domProps: { options: _vm.hiddenCategoryOptions },
                              on: { change: _vm.selectCategory }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.promotionsWithCategory, function(ref) {
              var category = ref.category;
              var promotions = ref.promotions;
              return _c(
                "magic-ui-accordion",
                {
                  key: category.id,
                  staticClass: "accordion accordion--promotions",
                  attrs: {
                    wide: "",
                    "no-animation": "",
                    "no-overflow": "",
                    controlled: "",
                    part: "accordion accordion--promotions",
                    "data-v-test-id": "promotions-category",
                    "initially-visible": category.visible
                  },
                  on: {
                    toggle: function($event) {
                      return _vm.openAccordion(category.id)
                    }
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "toggle",
                      attrs: {
                        slot: "toggle",
                        part: "toggle",
                        "data-v-test-id": "promotions-category-toggle"
                      },
                      slot: "toggle"
                    },
                    [
                      _c("magic-ui-text", {
                        staticClass: "title title--accordion",
                        attrs: {
                          tag: "h5",
                          part: "title title--accordion",
                          "data-v-test-id": "promotions-category-title",
                          content: category.title
                        }
                      }),
                      _vm._v(" "),
                      _c("magic-ui-badge", {
                        staticClass: "badge badge--promotions",
                        attrs: {
                          part: "badge badge--promotions",
                          "data-v-test-id": "promotions-category-badge"
                        },
                        domProps: { innerHTML: _vm._s(promotions.length) }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "promotion-cards",
                      attrs: {
                        slot: "content",
                        part: "promotion-cards",
                        "data-v-test-id": "promotions-category-content"
                      },
                      slot: "content"
                    },
                    _vm._l(promotions, function(promotion) {
                      return _c("magic-promotion-card", {
                        key: promotion.id,
                        staticClass: "promotion-card",
                        class: { "promotion-card--top-nav": _vm.topNavigation },
                        attrs: {
                          part: _vm.$p("promotion-card", {
                            "promotion-card--top-nav": _vm.topNavigation
                          }),
                          tag: _vm.getTag(promotion)
                        },
                        domProps: { promotion: promotion }
                      })
                    }),
                    1
                  )
                ]
              )
            })
          ]
        : _c(
            "div",
            {
              staticClass: "empty",
              attrs: { part: "empty", "data-v-test-id": "promotions-empty" }
            },
            [
              _c("magic-ui-icon", {
                staticClass: "icon",
                attrs: { badge: "", name: "promotions", part: "icon" }
              }),
              _vm._v(" "),
              _c("magic-ui-text", {
                staticClass: "title title--empty",
                attrs: {
                  tag: "h2",
                  part: "title title--empty",
                  content: _vm.$t("promotions-empty.title")
                }
              }),
              _vm._v(" "),
              _c("magic-ui-text", {
                staticClass: "description",
                attrs: {
                  part: "description",
                  content: _vm.$t("promotions-empty.description")
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "action", attrs: { part: "action" } },
                [
                  _c("magic-ui-link", {
                    attrs: {
                      button: "",
                      wide: "",
                      variant: "primary",
                      "data-v-test-id": "promotions-games-button"
                    },
                    domProps: {
                      to: { route: _vm.RoutablePage.GAMES },
                      innerHTML: _vm._s(_vm.$t("promotions-empty.games.button"))
                    }
                  }),
                  _vm._v(" "),
                  _c("magic-ui-link", {
                    attrs: {
                      hollow: "",
                      "no-margin": "",
                      button: "",
                      wide: "",
                      variant: "primary",
                      "data-v-test-id": "promotions-deposit-button"
                    },
                    domProps: {
                      to: { route: _vm.RoutablePage.WALLET_DEPOSIT },
                      innerHTML: _vm._s(
                        _vm.$t("promotions-empty.deposit.button")
                      )
                    }
                  })
                ],
                1
              )
            ],
            1
          )
    ],
    2
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-252392cf_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-252392cf";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
